module.exports = __webpack_public_path__ + "static/bg-topics-1bbf40685ac0c5bd3c48a9dbe4e798fc.jpg";